import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/* Configure and merge Tailwind classnames. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
